import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import { Stack, type StackProps } from "@mantine/core";
import type React from "react";
import type { ReactNode } from "react";
import SSDivider from "./Divider";

interface ISectionClassNames {
  root?: string;
  content?: string;
  title?: string;
}

interface ISectionProps {
  borderColor?: string;
  color?: string;
  title: ReactNode;
  icon: ReactNode;
  children?: ReactNode;
  fullHeight?: boolean;
  withDivider?: boolean;
  classNames?: ISectionClassNames;
}

const SSSection: React.FC<
  ISectionProps & Omit<StackProps, "classNames" | "title">
> = ({
  icon,
  title,
  borderColor = "border-primary-light",
  color = "bg-primary-darker",
  children,
  fullHeight = true,
  withDivider = true,
  classNames,
  onClick,
}) => {
  return (
    <Stack
      onClick={onClick}
      align="flex-start"
      className={`rounded-lg border-[1px] px-6 py-8 md:p-10 ${fullHeight ? "h-full" : ""} ${borderColor} ${color} ${classNames?.root}`}
    >
      <Stack
        align="flex-start"
        className={`w-full ${classNames?.content}`}
        justify="flex-start"
      >
        <SSHeadline
          props={{
            title: {
              className: `flex items-center pb-1 md:pb-2 ${classNames?.title}`,
              fz: 20,
            },
          }}
        >
          {icon}
          <SSWhiteText className="pl-2">{title}</SSWhiteText>
        </SSHeadline>
        {withDivider && <SSDivider className="w-full pb-1 md:pb-4" />}
        {children}
      </Stack>
    </Stack>
  );
};

export default SSSection;
